import { render, staticRenderFns } from "./VaccineAdd.vue?vue&type=template&id=6a347f27&scoped=true&"
import script from "./VaccineAdd.vue?vue&type=script&lang=js&"
export * from "./VaccineAdd.vue?vue&type=script&lang=js&"
import style0 from "./VaccineAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a347f27",
  null
  
)

export default component.exports